module.exports = __webpack_public_path__ + "static/media/top-img_7-mob@2x.f490857f.jpg";